import { createHouseAddress } from '../../shared/packages/address';

export const groupByHouses = (data) => {
  if (data === 'Error') return data;

  const output = data.reduce((acc, room) => {
    if (!acc[room.houseId]) {
      acc[room.houseId] = { name: createHouseAddress(room), rooms: [] };
    }

    acc[room.houseId].rooms.push(room);
    return acc;
  }, {});

  return Object.values(output).sort((a, b) => {
    return a.name.localeCompare(b.name, 'ru', { numeric: true });
  });
};
